var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-panel d-flex flex-column"},[_c('div',{staticClass:"panel-header flex-none",style:(_vm.headerStyle)},[_vm._t("header",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_vm._t("progress"),_c('div',{staticClass:"d-flex flex-column panel-content flex"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }